"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteListPropsMessage = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
exports.CompleteListPropsMessage = function (props) {
    var documentationLink = props.documentationLink;
    return (react_1.default.createElement("div", { className: "embed-insight-dialog-list-props-message" },
        react_1.default.createElement("span", { className: "gd-icon-circle-question s-circle_question question-mark-icon" }),
        react_1.default.createElement("a", { href: documentationLink, className: "gd-button-link-dimmed", target: "_blank", rel: "noreferrer" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "embedInsightDialog.complete.list.props.message" }))));
};
//# sourceMappingURL=CompleteListPropsMessage.js.map